// API Configuration for PTADash
// In production (Cloudflare Pages), connects to local server on user's machine
// In development, uses proxy configured in package.json

// Get saved port from localStorage or use default
export const getLocalServerPort = () => {
  const savedPort = localStorage.getItem('ptadash-local-port');
  return savedPort ? parseInt(savedPort, 10) : 3000;
};

// Set custom port (for users running server on different port)
export const setLocalServerPort = (port) => {
  localStorage.setItem('ptadash-local-port', port.toString());
  window.location.reload(); // Reload to apply new config
};

// Determine if we're in development or production
const isDevelopment = process.env.NODE_ENV === 'development';

// API base URL
// Development: use relative URLs (proxy handles it)
// Production: connect directly to localhost
export const API_BASE_URL = isDevelopment
  ? ''
  : `http://localhost:${getLocalServerPort()}`;

// Helper function to build full API URL
export const getApiUrl = (endpoint) => {
  // Ensure endpoint starts with /
  const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${API_BASE_URL}${path}`;
};

// Check if local server is reachable
export const checkServerConnection = async () => {
  try {
    const response = await fetch(getApiUrl('/api/health'), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.ok;
  } catch (error) {
    return false;
  }
};

// Export for use in components
const config = {
  API_BASE_URL,
  getApiUrl,
  checkServerConnection,
  setLocalServerPort,
  getLocalServerPort,
};

export default config;
